<div *ngIf="error" class="alert alert-danger" role="alert">
  Unable to load the service map right now. Please try again later.
</div>
<app-service-map
  [accent]="'bandwidth'"
  [entries]="productsList"
  [loading]="loading"
  [popupBuilder]="buildPopup"
  [pops]="commercialPopList"
  [title]="'Bandwidth Service Map'">
</app-service-map>
